import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { FaTachometerAlt, FaList, FaBox, FaUserCircle, FaBars, FaFileInvoiceDollar, FaUsers } from 'react-icons/fa';
import { useState } from 'react';
import Logo from '../common/Logo';
import { useAuth } from '../../features/auth/context/AuthContext';

const AdminLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [showSidebar, setShowSidebar] = useState(true);

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <div className="min-vh-100 bg-light">
      {/* Top Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
        <div className="container-fluid">
          <button
            className="btn btn-link text-light d-lg-none me-3"
            onClick={() => setShowSidebar(!showSidebar)}
          >
            <FaBars size={24} />
          </button>
          <Link to="/admin" className="navbar-brand d-flex align-items-center">
            <Logo size="small" showText={false} />
            <span className="ms-2 fw-bold">Admin</span>
          </Link>
          <div className="ms-auto d-flex align-items-center">
            <div className="dropdown">
              <button
                className="btn btn-link text-light dropdown-toggle"
                type="button"
                id="userDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <FaUserCircle size={24} className="me-2" />
                Admin
              </button>
              <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
                <li>
                  <Link to="/" className="dropdown-item">
                    Ver sitio
                  </Link>
                </li>
                <li><hr className="dropdown-divider" /></li>
                <li>
                  <button 
                    className="dropdown-item text-danger"
                    onClick={async () => {
                      try {
                        await logout();
                        navigate('/');
                      } catch (error) {
                        console.error('Error al cerrar sesión:', error);
                      }
                    }}
                  >
                    Cerrar sesión
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>

      <div className="container-fluid">
        <div className="row">
          {/* Sidebar */}
          <nav className={`col-lg-2 bg-dark sidebar ${showSidebar ? 'd-block' : 'd-none d-lg-block'}`}>
            <div className="position-sticky">
              <ul className="nav flex-column py-4">
                <li className="nav-item">
                  <Link
                    to="/admin"
                    className={`nav-link text-white d-flex align-items-center ${isActive('/admin')}`}
                    onClick={() => setShowSidebar(false)}
                  >
                    <FaTachometerAlt className="me-3" />
                    <span>Dashboard</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/admin/categories"
                    className={`nav-link text-white d-flex align-items-center ${isActive('/admin/categories')}`}
                    onClick={() => setShowSidebar(false)}
                  >
                    <FaList className="me-3" />
                    <span>Categorías</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/admin/products"
                    className={`nav-link text-white d-flex align-items-center ${isActive('/admin/products')}`}
                    onClick={() => setShowSidebar(false)}
                  >
                    <FaBox className="me-3" />
                    <span>Productos</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/admin/quotations"
                    className={`nav-link text-white d-flex align-items-center ${isActive('/admin/quotations')}`}
                    onClick={() => setShowSidebar(false)}
                  >
                    <FaFileInvoiceDollar className="me-3" />
                    <span>Cotizaciones</span>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    to="/admin/users"
                    className={`nav-link text-white d-flex align-items-center ${isActive('/admin/users')}`}
                    onClick={() => setShowSidebar(false)}
                  >
                    <FaUsers className="me-3" />
                    <span>Usuarios</span>
                  </Link>
                </li>
              </ul>
            </div>
          </nav>

          {/* Main content */}
          <main className="col-lg-10 ms-lg-auto px-4 py-4 content-wrapper">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
